// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "i[data-v-de83ab9c]{color:#b2b2ba;margin-right:10px}", ""]);
// Exports
module.exports = exports;
